// Each result belongs to one request, screen and identity/cache generation.
export function createNativeImageRequests(getContext) {
    let sequence = 0;
    let pending = null;
    return {
        begin(type, target) {
            const requestId = `photo-${Date.now()}-${++sequence}-${Math.random().toString(36).slice(2)}`;
            pending = { requestId, type, target, context: getContext(), sequence };
            return requestId;
        },
        take(message) {
            const request = pending;
            if (!request || !message.requestId || message.requestId !== request.requestId
                || message.type !== request.type || request.context !== getContext()) return null;
            pending = null; // Duplicate window/document deliveries cannot save twice.
            return { target: request.target, isCurrent: () => sequence === request.sequence && request.context === getContext() };
        },
        invalidate() { sequence++; pending = null; },
    };
}

export const supportsCorrelatedImagePicker = runtime => runtime?.capabilities?.imagePickerRequestId === true;
